import { RouteObject } from "react-router-dom";
import Auth from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import ResetPassword from "@/pages/ResetPassword";

export const authRoutes: RouteObject[] = [
  {
    index: true,
    element: <Auth />,
  },
  {
    path: "callback",
    element: <AuthCallback />,
  },
  {
    path: "reset-password",
    element: <ResetPassword />,
  },
];
